import '../../App.scss'
import React, { useState, useEffect } from 'react'
import Highlight from './Highlight'
import Hero from './Hero'
import Featured from './Featured'
import Events from './Events'
import Content from '../../data/events'
import { Helmet } from 'react-helmet'

export default function Home() {
  return (
    <div className="">
      <Helmet htmlAttributes>
        <title>AHRF</title>
        <meta name="og:title" content="AHRF" />
        <meta name="og:description" content="Ancient Historical Research Foundation" />
        <meta name="og:image" content="https://lh3.googleusercontent.com/pw/ACtC-3eQqJnzCis-0KMN3sZ8jCYfqKfGEkdU_39IGro2Uz19oVSg7sitzcqq-puADGI3egETSj_M96fZd9nw7oBchW6SGLF-Exs0E_14e6qE8hOdwKqE23nd5m6DInAj0Noix9rLlddbx4YcsL95wzcNcf3Bcg=w1679-h944-no?authuser=0" />
      </Helmet>
      <header className="Home">
        <Hero />
        <div>
          <div className="Columns-Between-Home">
            <Featured />
            <div className="Section">
              <h1>Upcoming Events</h1>
              {Content.map((data, index) => (

                <Events
                  content={data}
                />
              ))}

            </div>
          </div>
        </div>
        {/* <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSf-CK1vll7UXklskMTwpnC5BL48lEL4bif5r8fJXsUAysch7g/viewform?embedded=true" width="auto" height="1600px" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> */}
      </header>
    </div>
  );
}
